<!-- Navigation Container -->
<nav class="app-navigation" [class.collapsed]="isCollapsed" role="navigation" aria-label="Main navigation">
  
  <!-- Navigation Header -->
  <div class="nav-header">
    <div class="nav-brand" *ngIf="!isCollapsed">
      <h2 class="nav-title">Menu</h2>
    </div>
  </div>

  <!-- Navigation List -->
  <mat-nav-list class="nav-list">
    
    <!-- Main Navigation Items -->
    <div *ngFor="let item of navigationItems; trackBy: trackByItemId" class="nav-item-wrapper">
      
      <!-- Parent Item -->
      <mat-list-item 
        class="nav-item"
        [class.active]="isActiveRoute(item.route || '') || hasActiveChild(item)"
        [class.disabled]="item.disabled"
        [attr.aria-current]="isActiveRoute(item.route || '') ? 'page' : null"
        (click)="onItemClick(item)"
        [attr.title]="isCollapsed ? item.label : null">
        
        <!-- Icon -->
        <mat-icon class="nav-icon" [attr.aria-hidden]="true">{{ item.icon }}</mat-icon>
        
        <!-- Label -->
        <span class="nav-label" [class.sr-only]="isCollapsed">{{ item.label }}</span>
        
        <!-- Badge -->
        <span 
          *ngIf="item.badge && !isCollapsed" 
          class="nav-badge"
          [attr.aria-label]="item.badge + ' items'">
          {{ item.badge }}
        </span>
        
        <!-- Expand/Collapse Arrow for Parent Items -->
        <mat-icon 
          *ngIf="item.children && !isCollapsed" 
          class="nav-expand-icon"
          [class.expanded]="hasActiveChild(item)"
          [attr.aria-hidden]="true">
          expand_more
        </mat-icon>
        
      </mat-list-item>

      <!-- Child Items -->
      <div 
        *ngIf="item.children && !isCollapsed && (hasActiveChild(item) || isActiveRoute(item.route || ''))"
        class="nav-children"
        [@expandCollapse]
        role="group"
        [attr.aria-label]="item.label + ' submenu'">
        
        <mat-list-item 
          *ngFor="let child of item.children; trackBy: trackByItemId"
          class="nav-child-item"
          [class.active]="isActiveRoute(child.route || '')"
          [class.disabled]="child.disabled"
          [attr.aria-current]="isActiveRoute(child.route || '') ? 'page' : null"
          (click)="onItemClick(child)">
          
          <!-- Child Icon -->
          <mat-icon class="nav-child-icon" [attr.aria-hidden]="true">{{ child.icon }}</mat-icon>
          
          <!-- Child Label -->
          <span class="nav-child-label">{{ child.label }}</span>
          
          <!-- Child Badge -->
          <span 
            *ngIf="child.badge" 
            class="nav-child-badge"
            [attr.aria-label]="child.badge + ' items'">
            {{ child.badge }}
          </span>
          
        </mat-list-item>
        
      </div>
      
    </div>
    
  </mat-nav-list>

  <!-- Navigation Footer -->
  <div class="nav-footer" *ngIf="!isCollapsed">
    <mat-divider></mat-divider>
    <div class="nav-footer-content">
      <small class="nav-footer-text">INSEE Life Insurance v1.0</small>
    </div>
  </div>

</nav>